import * as React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { graphql } from 'gatsby'
import { IconChevronRight, IconPlus } from '../Icons'
import { getLabel, getValue } from '../../helpers/StringHelpers'
import { FilterIcons } from '../../icons/FilterIcons'
import { SortByFields } from '../../helpers/AlgoliaClient'

const GroupByLetterComponent = ({
  values,
  attribute,
  facetFilters,
  checkChecked,
  wrapperClassname,
  labelClassName,
  showQty,
  showCheckBox,
  showLabelText,
  handleFacet,
  parentState,
  showBackButton = true,
}) => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  const validLetters = values
    .map(v => v.name[0].toUpperCase())
    .filter((v, i, a) => a.indexOf(v) === i)
  const [selfExpanded, setSelfExpanded] = useState('')
  const selectLetter = letter =>
    (validLetters.indexOf(letter) !== -1 || letter === false) &&
    (parentState ? parentState[1](letter) : setSelfExpanded(letter))
  const expanded = parentState ? parentState[0] : selfExpanded

  return (
    <div className="h-full w-full flex flex-col overflow-hidden relative z-[100]">
      <div className="w-full grid grid-cols-4">
        {letters.map(letter => {
          const isSelected = letter === expanded
          const isValidLetter = validLetters.indexOf(letter) !== -1
          return (
            <button
              key={letter}
              onClick={() => selectLetter(letter)}
              className={
                'p-2 text-center ' +
                (isSelected ? 'bg-slate-200' : '') +
                (isValidLetter
                  ? ' hover:bg-slate-400 hover:text-white'
                  : 'opacity-50 cursor-default')
              }
            >
              {letter}
            </button>
          )
        })}
      </div>
      <div
        className={
          'w-full absolute h-full overflow-auto duration-200 bg-white  ' +
          (expanded ? 'left-0' : 'left-full')
        }
      >
        {showBackButton && expanded && (
          <button onClick={() => selectLetter(false)} className="pb-2">
            Back
          </button>
        )}
        {values
          .filter(f => f?.name[0]?.toUpperCase() === expanded)
          .map((facet, k) => {
            const input_id = 'check_' + attribute + '_' + k

            const isSelected = attribute in facetFilters && checkChecked(attribute, facet) !== true

            return (
              <div key={attribute + '_' + k} className="relative ">
                <input
                  type={'checkbox'}
                  id={input_id}
                  checked={checkChecked(attribute, facet)}
                  className={
                    showCheckBox
                      ? 'absolute top-[50%] right-5 -translate-y-[50%] peer scale-150 z-10 accent-red-700 '
                      : 'hidden'
                  }
                  onChange={e => {
                    if (handleFacet) {
                      handleFacet(attribute, facet, e)
                    }
                  }}
                />
                <label
                  htmlFor={input_id}
                  aria-label={facet.name}
                  className={`${isSelected ? wrapperClassname : ''} ${labelClassName(isSelected)}`}
                >
                  {/*these are the second layer of brands*/}
                  {showLabelText && (
                    <span className="ml-2">
                      {facet.name} {showQty && <>({facet.count})</>}
                    </span>
                  )}
                </label>
              </div>
            )
          })}
      </div>
    </div>
  )
}
GroupByLetterComponent.propTypes = {
  values: PropTypes.array,
  attribute: PropTypes.string,
  facetFilters: PropTypes.object,
  checkChecked: PropTypes.func,
  wrapperClassname: PropTypes.string,
  labelClassName: PropTypes.func,
  showQty: PropTypes.bool,
  showCheckBox: PropTypes.bool,
  showLabelText: PropTypes.bool,
  handleFacet: PropTypes.func,
  parentState: PropTypes.array,
  showBackButton: PropTypes.bool,
}

const TextSearchSelectorComponent = ({
  values,
  attribute,
  facetFilters,
  checkChecked,
  wrapperClassname,
  labelClassName,
  showQty,
  showCheckBox,
  showLabelText,
  handleFacet,
  prompt = 'Search Brands',
}) => {
  const [showAll, setShowAll] = useState(true)
  const [focus, setFocus] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState('')
  const [expanded, setExpanded] = useState('')
  const top5 = values.filter(f => f.name !== 'Estate Jewelry').slice(0, 5)
  // const onShowMore = React.useCallback(() => setShowAll(true), [setShowAll])
  const onToggleShowTop5 = React.useCallback(() => {
    setShowAll(s => !s)
    setSearchKeyword('')
  }, [])

  const filteredBrands = values.filter(
    f =>
      searchKeyword === '' ||
      searchKeyword
        .toLowerCase()
        .split(' ')
        .every(k => f.name.toLowerCase().includes(k))
  )

  return (
    <div className="relative ">
      {values.length > 5 && (
        <div className="relative pt-3">
          <label
            htmlFor={'filter-search-' + attribute}
            className={
              ' h-4 absolute top-0 left-2 text-gray-500 duration-100 ease-out bg-white px-2 ' +
              (focus || searchKeyword !== ''
                ? ' translate-y-1 text-xs '
                : 'translate-y-6 cursor-text')
            }
          >
            {prompt}
          </label>

          <input
            id={'filter-search-' + attribute}
            className={'border-2 h-12 w-10/12 mx-auto px-2 autofill:bg-white z-10 '}
            type="text"
            onChange={e => {
              setSearchKeyword(e.target.value)
            }}
            value={searchKeyword}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
          />
        </div>
      )}

      <div className={values.length > 5 ? 'h-[12.5em] overflow-auto' : ''}>
        {filteredBrands?.length > 0 ? (
          <NotGrouppedComponent
            values={showAll === false ? top5 : filteredBrands}
            attribute={attribute}
            facetFilters={facetFilters}
            checkChecked={checkChecked}
            wrapperClassname={wrapperClassname}
            labelClassName={labelClassName}
            showQty={showQty}
            showCheckBox={showCheckBox}
            showLabelText={showLabelText}
            handleFacet={handleFacet}
            parentState={[expanded, setExpanded]}
            showBackButton={false}
          />
        ) : (
          <p className="p-2 text-xl uppercase text-gray-400">No results found</p>
        )}
      </div>
      {values.length > 5 && (
        <div className="flex flex-row gap-4 w-full overflow-hidden">
          <button
            onClick={onToggleShowTop5}
            className={
              (filteredBrands?.length > 0
                ? ' border-gray-400 '
                : 'bg-red-600 text-white border-red-600 ') + ' relative border  px-2 py-1'
            }
          >
            {showAll ? 'Show Top 5' : 'Show All'}
          </button>
        </div>
      )}
    </div>
  )
}

TextSearchSelectorComponent.propTypes = {
  values: PropTypes.array,
  attribute: PropTypes.string,
  facetFilters: PropTypes.object,
  checkChecked: PropTypes.func,
  wrapperClassname: PropTypes.string,
  labelClassName: PropTypes.func,
  showQty: PropTypes.bool,
  showCheckBox: PropTypes.bool,
  showLabelText: PropTypes.bool,
  handleFacet: PropTypes.func,
  prompt: PropTypes.string,
}

const NotGrouppedComponent = ({
  values,
  attribute,
  facetFilters,
  checkChecked,
  wrapperClassname,
  labelClassName,
  showQty,
  showCheckBox,
  showLabelText,
  handleFacet,
  labelTextClassName = 'ml-2 ',
  className = 'relative',
}) => {
  return values.map((facet, k) => {
    const input_id = 'check_' + attribute + '_' + k

    const isSelected = attribute in facetFilters && checkChecked(attribute, facet) === true

    return (
      <div key={attribute + '_' + k} className={className}>
        <input
          type={'checkbox'}
          id={input_id}
          checked={checkChecked(attribute, facet)}
          className={
            showCheckBox
              ? 'absolute right-5 top-[50%] -translate-y-[50%] peer scale-150 bg-white z-10 accent-red-700 '
              : 'hidden'
          }
          onChange={e => {
            if (handleFacet) {
              handleFacet(attribute, facet, e)
            }
          }}
        />
        <label
          htmlFor={input_id}
          aria-label={facet.name}
          className={`${isSelected ? wrapperClassname : ''} ${labelClassName(isSelected)}`}
        >
          <FilterIcons type={facet.name} facet={attribute} />
          {showLabelText && (
            <span className={labelTextClassName}>
              {getValue(attribute, facet.name)}
              {showQty && <span className={'text-sm '}>&nbsp; ({facet.count})</span>}
            </span>
          )}
        </label>
      </div>
    )
  })
}

const RadioComponent = ({
  values,
  attribute,
  facetFilters,
  checkChecked,
  wrapperClassname,
  labelClassName,
  showQty,
  showCheckBox,
  showLabelText,
  handleFacet,
  labelTextClassName = 'ml-2',
}) => {
  return values.map((facet, k) => {
    const input_id = 'check_' + attribute + '_' + k

    const isSelected = attribute in facetFilters && checkChecked(attribute, facet) !== true

    return (
      <div key={attribute + '_' + k} className="relative">
        <input
          type={'radio'}
          id={input_id}
          checked={checkChecked(attribute, facet)}
          className={
            showCheckBox
              ? 'absolute right-5 top-[50%] -translate-y-[50%] peer scale-150 bg-white z-30 accent-red-700 '
              : 'hidden'
          }
          onChange={e => {
            if (handleFacet) {
              handleFacet(attribute, facet, e)
            }
          }}
        />
        <label
          htmlFor={input_id}
          aria-label={facet.name}
          className={`${isSelected ? wrapperClassname : ''} ${labelClassName(isSelected)}`}
        >
          <FilterIcons type={facet.name} facet={attribute} />
          {showLabelText && (
            <span className={labelTextClassName}>
              {getValue(attribute, facet.name)}
              {showQty && <span className="text-sm"> ({facet.count})</span>}
            </span>
          )}
        </label>
      </div>
    )
  })
}

const DropDownComponent = ({
  values,
  attribute,
  facetFilters,
  // checkChecked,
  showQty,
  handleFacet,
  prefix = '',
}) => {
  // <div>
  // <select>
  //   <option value="Relevance">Relevance</option>
  //   <option value="Price (high to low)">Price (high to low)</option>
  // ...
  // </select>
  // </div>
  // attribute = 'sort_by'
  // values =  [
  //   { name: 'Relevance', value: 'products', count: 0 },
  //   { name: 'Price (high to low)', value: 'products_by_price', count: 0 },
  //   { name: 'Price (low to high)', value: 'products_by_price_asc', count: 0 },
  //   { name: 'Newest first', value: 'products_by_date', count: 0 },
  //   { name: 'Oldest first', value: 'products_by_date_asc', count: 0 },
  // ]
  // map: 'Relevance' => (HTML) <option value="Relevance">Relevance</option>
  // selected={isSelected}
  const selectOptions = values.map((facet, k) => {
    const input_id = 'check_' + attribute + '_' + k
    // input_id = 'check_sort_by_0'
    // const isSelected = attribute in facetFilters && checkChecked(attribute, facet) === true
    return (
      <option key={input_id} value={facet.name}>
        {getValue(attribute, facet.name)}
        {showQty && <i className="text-sm not-italic">({facet.count})</i>}
      </option>
    )
  })
  // now select options looks like this:
  // <option value="Relevance">Relevance</option>
  // <option value="Price: Low to High">Price: Low to High</option>
  // <option value="Price: High to Low">Price: High to Low</option>
  // <option value="Newest Arrivals">Newest Arrivals</option>
  // <option value="Best Sellers">Best Sellers</option>

  const handleChange = React.useCallback(
    e => {
      if (handleFacet) {
        const facet = values.find(f => f.name === e.target.value)
        // attribute = 'sort_by'
        // facet = { name: 'Relevance', value: 'products', count: 0 }
        // e = { target: { value: 'Relevance' }, ... }
        handleFacet(attribute, facet, e)
      }
    },
    [values, handleFacet]
  )

  const sortByLabel = () => {
    let label = values[0].name
    if (facetFilters && facetFilters[attribute] && facetFilters[attribute][0]) {
      label = facetFilters[attribute][0].split(':')[1].trim()
    }
    return values.find(v => v.name === label).htmlLabel
  }

  return (
    <div className="relative justify-center items-center h-16 ">
      <select
        id={attribute}
        name={attribute}
        defaultValue={
          facetFilters && facetFilters[attribute] && facetFilters[attribute][0]
            ? facetFilters[attribute][0]
            : null
        }
        onChange={handleChange}
        className="indent-[5.5rem] text-transparent group py-4 flex w-full duration-300 focus:outline-none outline-none appearance-none cursor-pointer h-16 mb-5 border-b border-b-transparent  hover:bg-gray-50 hover:border-gray-300 pt-[1.1rem]"
      >
        {selectOptions}
      </select>
      <label
        className="absolute top-0 left-2 py-4 font-bold uppercase text-lg whitespace-nowrap pointer-events-none"
        htmlFor={attribute}
      >
        {prefix}
        <i>{sortByLabel()}</i>
      </label>
      <div className="absolute  top-5 right-2 rotate-90 z-10 text-black  pointer-events-none">
        <IconChevronRight />
      </div>
    </div>
  )
}
DropDownComponent.propTypes = {
  values: PropTypes.array,
  attribute: PropTypes.string,
  facetFilters: PropTypes.object,
  checkChecked: PropTypes.func,
  showQty: PropTypes.bool,
  handleFacet: PropTypes.func,
  prefix: PropTypes.string,
}

export const SortByComponent = ({ facetFilters, handleFacet }) => {
  const checkChecked = (key, facet) => {
    const kv = key + ':' + facet.name
    if (key in facetFilters) {
      if (facetFilters[key].indexOf(kv) >= 0) return true
    } else if (SortByFields[0].name === facet.name) return true
    return false
  }
  let wrapperClassname =
    'before:block before:absolute before:w-full before:h-full before:inset-0 relative inline-block hover:before:hidden'
  let labelClassName = isSelected =>
    'flex px-4 py-2 hover:bg-gray-50 hover:text-red-600 mix-blend-multiply duration-150 cursor-pointer items-center' +
    (isSelected ? ' text-red-600' : '')
  let labelTextClassName = 'ml-2  '
  return (
    <div className={'relative space-y-3 flex flex-col '}>
      <RadioComponent
        values={SortByFields}
        attribute={'sort_by'}
        facetFilters={facetFilters}
        checkChecked={checkChecked}
        wrapperClassname={wrapperClassname}
        labelClassName={labelClassName}
        showQty={false}
        showCheckBox={true}
        showLabelText={true}
        handleFacet={handleFacet}
        labelTextClassName={labelTextClassName}
      />
    </div>
  )
}
SortByComponent.propTypes = {
  facetFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  handleFacet: PropTypes.func.isRequired,
}
const FilterFindYourWatch = ({
  facets,
  facetFilters,
  handleFacet,
  collapsed = false,
  // sortByOption = false,
  // mode = 'filter',
}) => {
  // console.log('facets', facets)
  const initState = {}
  Object.keys(facetFilters).forEach(key => (initState[key] = true))
  const [collapsedItems, setCollapsedItems] = useState(initState)
  const checkChecked = (key, facet) => {
    if (key in facetFilters) {
      const kv = key + ':' + facet.name
      if (facetFilters[key].indexOf(kv) >= 0) return true
    }
    return false
  }

  const getFloatValue = s => {
    try {
      const val = parseFloat(
        s
          .replace('-', ' ')
          .split(' ')[0]
          .replace(',', '')
          .replace('$', '')
          .replace(/[^0-9.]/g, '')
      )
      if (isNaN(val)) return 0
      return val
    } catch {
      return 0
    }
  }
  const expand = prop => {
    const c = { ...collapsedItems }
    if (prop in c) {
      delete c[prop]
    } else {
      c[prop] = true
    }
    setCollapsedItems(c)
  }
  const isCollapsed = prop => {
    if (collapsed) return !(prop in collapsedItems)
    return prop in collapsedItems
  }
  const priority = [
    'price_filter',
    'item_type',
    'brand',
    'model',
    'model_no',
    'size',
    'case_size_mm',
    'case_shape',
    'case_material',
    'band_type',
    'band_color',
    'band_metal',
    'gender_mfu',
    'watch_style',
    'metal_name',
    'age_attribute',
    'extras',
  ]

  const extras = ['original_box', 'original_papers', 'booklets']

  let found = false
  for (let i = 0; i < extras.length; i++) {
    if (extras[i] in facets) {
      let extraFacets = facets[extras[i]]
        .filter(f => f.name === '1')
        .map(f => ({ ...f, name: extras[i], key: extras[i], value: '1' }))
      if (extraFacets.length > 0) {
        facets['extras'] = facets['extras'] || []
        facets['extras'].push(extraFacets[0])
      }
      delete facets[extras[i]]
    }
  }

  const showCaseSize = 'size' in facetFilters
  const showModelFilters =
    'brand' in facetFilters || !('brand' in facets) || facets.brand.length <= 1
  const showModelNoFilters =
    showModelFilters &&
    ('model' in facetFilters || !('model' in facets) || facets.model.length <= 1)
  const showBandColor =
    'band_type' in facetFilters &&
    facetFilters?.band_type?.indexOf('band_type:Metal Bracelet') === -1
  const showBandMaterial =
    (showBandColor && 'band_color' in facetFilters) ||
    facetFilters?.band_type?.indexOf('band_type:Metal Bracelet') >= 0
  const showFilter = filter => {
    if (filter === 'brand') return true
    if (filter === 'model') return showModelFilters
    if (filter === 'model_no') return showModelNoFilters
    if (filter === 'band_type') return true
    if (filter === 'band_color') return showBandColor
    if (filter === 'band_metal') return showBandMaterial
    if (filter === 'head_metal') return false
    if (filter === 'case_size') return showCaseSize
    if (filter === 'case_size_mm') return showCaseSize
    return true
  }
  const sortValues = (filter, values) => {
    switch (filter) {
      case 'brand':
        return values.sort((a, b) => b.count - a.count)
      case 'price_filter':
      case 'case_size_mm':
        return values.sort((a, b) => getFloatValue(a.name) - getFloatValue(b.name))
      case 'age_attribute':
        return values.sort((a, b) => getFloatValue(b.name) - getFloatValue(a.name))
      case 'jewelry_type':
        return values.sort((a, b) => {
          if (a.name === 'Other') return 1
          if (b.name === 'Other') return -1
          return b.count - a.count
        })
      default:
        return values
    }
  }
  const sortedFilters = Object.keys(facets)
    // sort by priority
    .sort((a, b) => {
      const aIndex = priority.indexOf(a)
      const bIndex = priority.indexOf(b)
      if (aIndex === -1 && bIndex === -1) return 0
      if (aIndex === -1) return 1
      if (bIndex === -1) return -1
      return aIndex - bIndex
    })
    .filter(key => ['extras'].indexOf(key) !== -1 || facets[key].length > 1)

  return (
    <>
      {sortedFilters.map(key => {
        if (key === 'categories.id') return <React.Fragment key={key}></React.Fragment>
        if (key === 'categories.name') return <React.Fragment key={key}></React.Fragment>
        if (!showFilter(key)) return <React.Fragment key={key}></React.Fragment>

        //const values = key === 'sort_by' ? SortByFields : sortValues(key, facets[key])
        let listClassName = 'border-b border-gray-200 overflow-auto '

        let FilterComponent = NotGrouppedComponent
        const props = {
          values: sortValues(key, facets[key]),
          attribute: key,
          facetFilters: facetFilters,
          checkChecked: checkChecked,
          wrapperClassname:
            'before:block before:absolute before:w-full before:h-full before:inset-0 relative inline-block hover:before:hidden',
          labelClassName: isSelected =>
            ' flex px-4 py-2 hover:bg-gray-50 hover:text-red-600 mix-blend-multiply duration-150 cursor-pointer items-center' +
            (isSelected ? ' text-red-600' : ''),
          labelTextClassName: 'ml-2',
          showQty: true,
          showCheckBox: true,
          showLabelText: true,
          handleFacet: handleFacet,
        }
        switch (key) {
          case 'model':
            listClassName = 'overflow-auto max-h-[45vh]'
            FilterComponent = TextSearchSelectorComponent
            props.prompt = 'Search Models'
            break
          case 'brand':
            listClassName = 'overflow-auto max-h-[45vh]'
            FilterComponent = TextSearchSelectorComponent
            break
          case 'jewelry_type':
            listClassName = 'grid grid-cols-3  md:grid-cols-2 lg:grid-cols-3 gap-2 '
            props.labelTextClassName = ''
            props.labelClassName = isSelected =>
              'flex flex-col justify-center text-center items-center hover:bg-gray-100 cursor-pointer p-2 rounded-lg duration-150' +
              (isSelected ? ' text-red-600' : '')
            props.showLabelText = true
            props.showCheckBox = false
            props.showQty = false
            break
          case 'case_size_mm':
          case 'age_attribute':
            listClassName = 'grid grid-cols-3  md:grid-cols-2 lg:grid-cols-3  '
            props.labelClassName = isSelected =>
              'flex justify-center p-2 hover:bg-slate-100 cursor-pointer' +
              (isSelected ? ' text-red-600' : '')
            props.showLabelText = true
            props.showCheckBox = false
            props.showQty = false
            break
          case 'price_filter':
            props.showQty = false
            break
          case 'dial':
          case 'band_color':
            listClassName = 'grid gap-3 grid-cols-4 py-2'
            props.labelClassName = isSelected =>
              'flex justify-center cursor-pointer ' + (isSelected ? ' text-red-600' : '')
            props.showLabelText = false
            props.showCheckBox = false
            break
        }

        return (
          <div
            key={key}
            className={
              'w-full '
              //(mode === 'filter' && key === 'sort_by' ? ' hidden md:block ' : '') +
              //(mode !== 'filter' && key !== 'sort_by' ? ' hidden md:block' : '')
              //(mode !== 'filter' && key !== 'sort_by ')
              //</>? 'hidden md:block'
              //: '')
            }
          >
            <button
              className={
                (isCollapsed(key)
                  ? 'border-l-0 border-l-gray-300 '
                  : 'border-l-4 border-l-gray-300 ') +
                'py-4 font-bold uppercase text-lg w-full group border-b border-transparent hover:border-gray-300 duration-300 px-2 hover:bg-gray-50 flex'
              }
              onClick={() => {
                expand(key)
              }}
            >
              <div className={'w-full text-left whitespace-nowrap'}>{getLabel(key)}</div>
              <div className={'text-right'}>
                <IconPlus
                  className={
                    (!isCollapsed(key) ? 'rotate-45' : 'rotate-0') +
                    ' group-hover:text-gray-600 duration-300 ease-[cubic-bezier(.82,-0.32,.43,1.34)] text-gray-400 text-sm'
                  }
                />
              </div>
            </button>
            <div className={!isCollapsed(key) ? 'relative  ' + listClassName : 'hidden'}>
              <FilterComponent {...props} />
            </div>
          </div>
        )
      })}
    </>
  )
}
/*
{key === 'brand' ? (
  !isCollapsed(key) && (
    <TextSearchSelectorComponent
      values={values}
      attribute={key}
      facetFilters={facetFilters}
      checkChecked={checkChecked}
      wrapperClassname={wrapperClassname}
      labelClassName={labelClassName}
      showQty={showQty}
      showCheckBox={showCheckBox}
      showLabelText={showLabelText}
      handleFacet={handleFacet}
    />
  )
) : (
  <div className={!isCollapsed(key) ? 'relative  ' + listClassName : 'hidden'}>
    <NotGrouppedComponent
      values={values}
      attribute={key}
      facetFilters={facetFilters}
      checkChecked={checkChecked}
      wrapperClassname={wrapperClassname}
      labelClassName={labelClassName}
      showQty={showQty}
      showCheckBox={showCheckBox}
      showLabelText={showLabelText}
      handleFacet={handleFacet}
      labelTextClassName={labelTextClassName}
    />
  </div>
)}
*/

FilterFindYourWatch.propTypes = {
  facets: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
      })
    )
  ).isRequired,
  facetFilters: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  handleFacet: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
  sortByOption: PropTypes.bool,
  mode: PropTypes.string,
}

export const query = graphql`
  fragment FacetFilters on STRAPI_PRODUCTConnection {
    price_filter: group(field: price_filter) {
      count: totalCount
      name: fieldValue
    }
    item_type: group(field: item_type) {
      count: totalCount
      name: fieldValue
    }
    brand: group(field: brand) {
      count: totalCount
      name: fieldValue
    }
    # We show it only when brand is specified
    model: group(field: model) {
      count: totalCount
      name: fieldValue
    }

    # We show it only when model is specified
    model_no: group(field: model_no) {
      count: totalCount
      name: fieldValue
    }
    size: group(field: size) {
      count: totalCount
      name: fieldValue
    }
    case_size_mm: group(field: case_size_mm) {
      count: totalCount
      name: fieldValue
    }
    case_shape: group(field: case_shape) {
      count: totalCount
      name: fieldValue
    }
    case_material: group(field: case_material) {
      count: totalCount
      name: fieldValue
    }

    band_type: group(field: band_type) {
      count: totalCount
      name: fieldValue
    }
    band_color: group(field: band_color) {
      count: totalCount
      name: fieldValue
    }

    gender_mfu: group(field: gender_mfu) {
      count: totalCount
      name: fieldValue
    }
    watch_style: group(field: watch_style) {
      count: totalCount
      name: fieldValue
    }
    metal_name: group(field: metal_name___strapi_json_value) {
      count: totalCount
      name: fieldValue
    }
    age_attribute: group(field: age_attribute) {
      count: totalCount
      name: fieldValue
    }
    main_stone: group(field: main_stone) {
      count: totalCount
      name: fieldValue
    }
    jewelry_type: group(field: jewelry_type) {
      count: totalCount
      name: fieldValue
    }
    dial: group(field: dial) {
      count: totalCount
      name: fieldValue
    }
    qty: group(field: qty) {
      count: totalCount
      name: fieldValue
    }
    original_box: group(field: original_box) {
      count: totalCount
      name: fieldValue
    }
    original_papers: group(field: original_papers) {
      count: totalCount
      name: fieldValue
    }
    booklets: group(field: booklets) {
      count: totalCount
      name: fieldValue
    }
  }
`

export default FilterFindYourWatch
